import moment from 'moment'
import Slider from 'rc-slider'

import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'
import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { fetchAllBusinesses } from '../../actions/businesses_all'
import { fetchAllMetrics } from '../../actions/metrics'

import {
  DATE_FORMAT_METRICS,
  METRICS_SLIDER_VALUE_30_DAYS,
  METRICS_SLIDER_VALUE_7_DAYS,
  METRICS_SLIDER_VALUE_90_DAYS_TIME,
  METRICS_SLIDER_VALUE_TODAY,
} from '../../config'
import { ButtonBackDiv, DivContentBox } from '../common/styled'
import TotalTx from '../visualization_components/total_tx'
import TxByCountry from '../visualization_components/tx_by_country'
import TxStatusBreakDown from '../visualization_components/tx_status_breakdown'
import TxStatusesComplete from '../visualization_components/tx_statuses_complete'
import TxStatusesHold from '../visualization_components/tx_statuses_hold'
import BusinessFilterRedux from '../transaction_grid/business_filter_redux'

const ChartRow = styled.div`
  display: flex;

  > div {
    flex: 1;
    margin: 0.5rem;
  }
`

class TxVisualization extends PureComponent {
  marks = {
    [METRICS_SLIDER_VALUE_TODAY]: 'Today',
    [METRICS_SLIDER_VALUE_7_DAYS]: '7 Days',
    [METRICS_SLIDER_VALUE_30_DAYS]: '30 Days',
    [METRICS_SLIDER_VALUE_90_DAYS_TIME]: '90 days',
  }

  constructor(props) {
    super(props)
    this.state = {
      dateFrom: moment().subtract(30, 'days').format(DATE_FORMAT_METRICS),
      dateTo: moment().format(DATE_FORMAT_METRICS),
      sliderValue: METRICS_SLIDER_VALUE_30_DAYS,
      data: {},
      currentData: {},
      timeSpan: this.marks[METRICS_SLIDER_VALUE_30_DAYS],
      filter: {
        business: null,
      },
    }
  }

  percentFormatter = (v) => (this.marks.hasOwnProperty(v) ? this.marks[v] : null)

  handleSliderChange = (sliderValue) => {
    const { fetchAllMetrics } = this.props
    let dateTo = moment().format(DATE_FORMAT_METRICS)
    let dateFrom = null
    switch (sliderValue) {
      case METRICS_SLIDER_VALUE_7_DAYS:
        dateFrom = moment().subtract(7, 'days').format(DATE_FORMAT_METRICS)
        break
      case METRICS_SLIDER_VALUE_30_DAYS:
        dateFrom = moment().subtract(30, 'days').format(DATE_FORMAT_METRICS)
        break
      case METRICS_SLIDER_VALUE_90_DAYS_TIME:
        dateFrom = moment().subtract(90, 'days').format(DATE_FORMAT_METRICS)
        break
      default:
        dateFrom = moment().format(DATE_FORMAT_METRICS)
        dateTo = null
    }

    this.setState({ dateFrom, dateTo, sliderValue, timeSpan: this.marks[sliderValue] })
    fetchAllMetrics(dateFrom, dateTo, this.state.filter.business)
  }

  updateFilter = (event) => {
    const { props, state } = this
    const { fetchAllMetrics } = props
    const filter = { ...state.filter, ...event }
    this.setState({ filter })
    fetchAllMetrics(state.dateFrom, state.dateTo, filter.business)
  }

  updateBusinessFilter = (business) => {
    const { props, state } = this
    const { fetchAllMetrics } = props
    const filter = { ...state.filter, ...{ business } }
    this.setState({ filter })
    fetchAllMetrics(state.dateFrom, state.dateTo, filter.business)
  }

  componentDidMount() {
    const { state, props } = this
    props.fetchAllMetrics(state.dateFrom, state.dateTo, state.filter.business)
    props.fetchAllBusinesses()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { state, props } = this
    if (prevProps.filter !== this.props.filter) {
      if (props.filter && props.filter.country) {
        props.fetchAllMetrics(state.dateFrom, state.dateTo, state.filter.business, props.filter.country)
      } else {
        props.fetchAllMetrics(state.dateFrom, state.dateTo, state.filter.business)
      }
    }
  }

  render() {
    const { props, state } = this
    return (
      <div className='animated fadeIn'>
        <ButtonBackDiv>
          <Button bsPrefix='btn btn-w-m btn-default shadow' onClick={() => props.history.push('/')}>
            <i className='fa fa-arrow-left' />
            Back
          </Button>
        </ButtonBackDiv>
        <DivContentBox>
          <div className='ibox float-e-margins animated fadeIn section-shadow'>
            <div
              className='ibox-title round-corner-box-top'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <h2>Metrics</h2>
              <BusinessFilterRedux updateBusinessFilter={this.updateBusinessFilter} />
            </div>
            <div className='ibox-content round-corner-box-bottom'>
              <div className='ibox float-e-margins animated fadeIn'>
                <div className='row' style={{ paddingLeft: 20, marginBottom: 35 }}>
                  <div className='animated fadeIn col-lg-6'>
                    <Slider
                      value={this.state.sliderValue}
                      marks={this.marks}
                      included={false}
                      step={null}
                      tipFormatter={this.percentFormatter}
                      onChange={this.handleSliderChange}
                    />
                  </div>
                </div>

                <ChartRow>
                  <TotalTx timeSpan={state.timeSpan} />
                  <TxStatusBreakDown timeSpan={state.timeSpan} />
                </ChartRow>
                <ChartRow>
                  <TxStatusesHold timeSpan={state.timeSpan} />
                  <TxStatusesComplete timeSpan={state.timeSpan} />
                  <TxByCountry timeSpan={state.timeSpan} />
                </ChartRow>
              </div>
            </div>
          </div>
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  data: state.allMetrics.results,
  isAuthenticated: state.auth.isAuthenticated,
  businesses: state.businessesAll.businesses,
  filter: state.metricsFilter.filter,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchAllMetrics,
      fetchAllBusinesses,
      navigateHome: () => ownProps.history.push('/'),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxVisualization))
